import styled, { css } from 'styled-components/macro';
import { Input } from '../inputs.styled';
import { ru } from 'assets/icons';

export const CustomizedInput = styled(Input)`
  ${({ theme }) => css`
    padding: ${theme.spacings.componentOnly} 36px
      ${theme.spacings.componentOnly} 76px;
  `}
`;

export const CountryWrapper = styled.div<{ $isDisabled?: boolean }>`
  ${({ theme, $isDisabled }) => css`
    padding-block: ${theme.spacings.componentOnly};
    padding-inline: ${theme.spacings.s};
    position: absolute;
    z-index: 2;
    left: 1px;
    top: 1px;
    border-radius: ${theme.radiuses.xs} 0 0 ${theme.radiuses.xs};
    border-right: 1px solid
      ${$isDisabled
        ? theme.semantic.border.disabled
        : theme.semantic.border.control};
    background-color: ${$isDisabled
      ? theme.semantic.field.bgDisabled
      : theme.semantic.field.bgPrefixSubtle};
    display: flex;
    align-items: center;
    gap: ${theme.spacings.xs};
    color: ${$isDisabled
      ? theme.semantic.text.disabled
      : theme.semantic.text.default};
    cursor: default;

    ${theme.fonts['body-14'].css}

    ${$isDisabled &&
    css`
      cursor: not-allowed;
      pointer-events: none;
    `}
  `}
`;

export const RuIcon = styled.img.attrs({ src: ru })`
  width: 16px;
  height: 16px;
`;
